import styled from 'styled-components'
import { breakpoints, theme } from '@gassan-ui'

export const Wrap = styled.div<{ isShown: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: ${p => (p.isShown ? 1 : 0)};
  transform: ${p => (p.isShown ? 'translateY(0)' : 'translateY(1rem)')};
  pointer-events: ${p => (p.isShown ? 'all' : 'none')};
  transition: all 0.2s ease-in-out;

  @media screen and (min-width: ${breakpoints.medium}) {
    transform: ${p => (p.isShown ? 'translateX(0)' : 'translateX(-1rem)')};
  }
`

export const ContentWrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: auto;
  width: 90%;
  margin: 0 auto;
  background: ${p => p.theme.rolex.colors.shades[100]};

  @media screen and (min-width: ${breakpoints.medium}) {
    height: 100%;
    width: 367px;
    top: 0;
    right: initial;
  }
`

export const CloseWindow = styled.button`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  outline: none;
  border: none;
  background: transparent;
`

export const ImgWrap = styled.div`
  display: none;

  @media screen and (min-width: ${breakpoints.medium}) {
    display: block;

    img {
      width: 100%;
      height: auto;
    }
  }
`

export const CloseButton = styled.button`
  height: 25px;
  width: 25px;
  background: transparent;
  position: absolute;
  top: 0;
  right: 0;
  color: ${theme.rolex.colors.shades[900]};
  outline: none;
  transition: all 0.2s ease-in-out;

  svg {
    height: 12px;
    width: 14px;
  }

  &:hover {
    color: ${theme.rolex.colors.primary};
  }
`
